import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';

import { CookieService } from 'angular2-cookie/services/cookies.service';
import {
    SharedLibsModule,
    SharedCommonModule,
    CSRFService,
    AuthService,
    AuthServerProvider,
    AccountService,
    UserService,
    StateStorageService,
    LoginService,
    LoginModalService,
    Principal,
    JhiTrackerService,
    HasAnyAuthorityDirective,
    JhiLoginModalComponent
} from './';
import {PageControlComponent} from './page-control/page-control.component';
import {RouterModule} from '@angular/router';
import {ApiService} from './services/api.service';
import {ReplacePipe} from './replace-pipe/replace.pipe';
import {RoundUpPipe} from './round-up-pipe/round-up.pipe';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {TruncatePipe} from './truncate-pipe/truncate.pipe';
import {MomentModule} from 'angular2-moment';
import {EventManagerService} from './services/event-manager.service';
import {FirstPartPipe} from './first-part/first-part.pipe';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {RoutingDataService} from './services/routing-data.service';
import {DatexPipe} from './datex-pipe/datex.pipe';
import {OsmNominatimService} from './services/osm-nominatim.service';
import { WinterService } from './services/winter.service';
import { PasswordResetService } from './login/password-reset.service';
import {RoundPipe} from './round-pipe/round.pipe';
import {MonthNamePipe} from './month-name-pipe/month-name.pipe';
import { MassSmsComponent } from './mass-sms/mass-sms.component';
import { MailComposerComponent } from './mail-composer/mail-composer.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ImageCarouselComponent } from './image-carousel/image-carousel.component';
import { FilterByPipe } from './filter-by-pipe/filter-by.pipe';
import { FileService } from './services/file.service';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { FileSizePipe } from './file-size-pipe/file-size.pipe';
import { HttpClientModule } from '@angular/common/http';
import { MaintenanceService } from './services/maintenance.service';
import { MaintenanceModalComponent } from './maintenance-modal/maintenance-modal.component';
import { WebBaseDataService } from './web-base-data/web-base-data.service';
import {CompressImageService} from './services/compress-image.service';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import {ExcelService} from './services/excel.service';
import {MerchantService} from './services/merchant.service';
import { SendMarketwebsitePreviewComponent } from './send-marketwebsite-preview/send-marketwebsite-preview.component';
import {MarketwebsitePreviewMassSmsComponent} from './marketwebsite-preview-mass-sms/marketwebsite-preview-mass-sms.component';

@NgModule({
  imports: [
    SharedLibsModule,
    SharedCommonModule,
    RouterModule,
    CurrencyMaskModule,
    MomentModule,
    NgbModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  declarations: [
    JhiLoginModalComponent,
    HasAnyAuthorityDirective,
    PageControlComponent,
    ReplacePipe,
    RoundPipe,
    RoundUpPipe,
    TruncatePipe,
    FirstPartPipe,
    DatexPipe,
    MonthNamePipe,
    MassSmsComponent,
    MarketwebsitePreviewMassSmsComponent,
    MailComposerComponent,
    ImageCarouselComponent,
    FilterByPipe,
    UploadModalComponent,
    FileSizePipe,
    MaintenanceModalComponent,
    MultiSelectComponent,
    SendMarketwebsitePreviewComponent
  ],
  providers: [
    CookieService,
    LoginService,
    LoginModalService,
    AccountService,
    StateStorageService,
    Principal,
    CSRFService,
    JhiTrackerService,
    AuthServerProvider,
    AuthService,
    UserService,
    DatePipe,
    RoundPipe,
    ApiService,
    RoutingDataService,
    EventManagerService,
    { provide: LOCALE_ID, useValue: 'de-DE' },
    OsmNominatimService,
    WinterService,
    PasswordResetService,
    MonthNamePipe,
    DecimalPipe,
    FileService,
    MaintenanceService,
    WebBaseDataService,
    CompressImageService,
    ExcelService,
    MerchantService
  ],
  entryComponents: [
    JhiLoginModalComponent,
    MassSmsComponent,
    MarketwebsitePreviewMassSmsComponent,
    MailComposerComponent,
    ImageCarouselComponent,
    UploadModalComponent,
    MaintenanceModalComponent,
    SendMarketwebsitePreviewComponent
  ],
  exports: [
    SharedCommonModule,
    JhiLoginModalComponent,
    HasAnyAuthorityDirective,
    DatePipe,
    PageControlComponent,
    ReplacePipe,
    RoundUpPipe,
    RoundPipe,
    TruncatePipe,
    FirstPartPipe,
    CurrencyMaskModule,
    MomentModule,
    DatexPipe,
    MonthNamePipe,
    MassSmsComponent,
    MarketwebsitePreviewMassSmsComponent,
    MailComposerComponent,
    ImageCarouselComponent,
    FilterByPipe,
    UploadModalComponent,
    FileSizePipe,
    MaintenanceModalComponent,
    MultiSelectComponent,
    SendMarketwebsitePreviewComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts